import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function CiudadJardin() {
  return <NeighborhoodPageContent slug="ciudad-jardin" />;
}